import { getOutByIndex } from "@/shared/utils/outs";
import { usePool } from "@/features/pool/usePool";
import { isFirmwareBefore } from "@/shared/utils/firmware";
import { useOut } from "@/features/out/useOut";

/**
 * Disable buttons on for older firmware https://trello.com/c/9E8ZfFlD/262-bouton-triggerstop-triggeronly
 */

export const useShouldHideControlButtons = () => {
  const pool = usePool();
  const out = useOut();

  if (isFirmwareBefore(pool.tabSW, "200")) {
    return true;
  }

  if (isFirmwareBefore(pool.tabSW, "208E")) {
    return (
      ["OUT_PH", "OUT_FLOC", "OUT_TRAIT", "OUT_TRAIT2"].includes(
        getOutByIndex(out.value.index).name
      ) && out.value.recurrence?.mode !== "unique"
    );
  }

  return false;
};
